import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Heading, Text } from '../../Elements/Elements';

import classes from './TextWidget.module.scss';

const TextWidget = ({ data }) => {
  const { t } = useTranslation(['activity']);

  return (
    <section className={classes.box}>
      <Heading>{data.title}</Heading>
      <div className={classes.body}>
        <Text className={classes.value}>{data.value}</Text>
        <div className={classes.info}>
          <div className={classes.info_wrap}>
            <Text type="p" className={classes.info_item}>
              <Text className={classes.info_item__title}>{data.users}</Text>
              <Text size={2}>{t('activity:about.USERS')}</Text>
            </Text>
          </div>
          <div className={classes.info_wrap}>
            <Text type="p" className={classes.info_item}>
              <Text className={classes.info_item__title}>{data.gateways}</Text>
              <Text size={2}>{t('activity:platform.GATEWAYS')}</Text>
            </Text>
          </div>
        </div>
      </div>
    </section>
  );
};

TextWidget.propTypes = {
  data: PropTypes.object
};

export default TextWidget;
